import { useSessionNotification } from '../../../utils/actionableNotifications';
import React from 'react';

import { useNavigate } from 'react-router-dom';
import AppTheme from '../../../components/theme/AppTheme';
import { useAttendance } from '../viewmodels/AttendanceProvider';
import { useAttendanceNotifications } from '../viewmodels/useAttendanceNotifications';
export default function AttendanceNotifications() {
  const [notices, holder] = useSessionNotification(), navigate = useNavigate(), vm = useAttendance();
  useAttendanceNotifications({ show: notices.info, dismiss: notices.destroy, error: message => notices.warning({ message }), navigate }, vm?.state?.enabled === true);
  return <AppTheme>{holder}</AppTheme>;
}
